import type { Ref } from 'vue';
import type { HekateDisplayForm } from '@onshape/www-inertia';
import { CAD_PLAN_ID, FieldHtmlNameUtil, CAM_APP_PLAN_ID_MAP, Trans } from '@onshape/www-inertia';
import ExternalUtil from '../../../../ExternalUtil';
import CommonPreFilledProgressiveProfile from './CommonPreFilledProgressiveProfileDefinition';
import { isSignupTestEnabled } from '~/hekate-www/external/util/E2eTestingUtil';

/** Only show fields that can't be sso filled, redirect to login if the user is not logged in  */
export default class CamForFirstRoboticsProgressiveProfile extends CommonPreFilledProgressiveProfile {
  public override async realtimeBranchModifications({
    formDefinition,
  }: {
    formDefinition: Ref<HekateDisplayForm>;
  }): Promise<void> {
    super.realtimeBranchModifications({ formDefinition });
    formDefinition.value.isRecaptcha = !isSignupTestEnabled();

    const planId = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.planId,
    });
    planId.val = CAD_PLAN_ID.EDU_EDUCATOR as string;
    const appPlanId = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.appPlanId,
    });
    appPlanId.val = CAM_APP_PLAN_ID_MAP.CAM.CAM_STUDIO_EDU as string;

    const emailField = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.email,
    });
    emailField.label = Trans.byValue('Educator Plan Owner Email');
    const whatIsYourExperienceField = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.whatIsYourExperience,
    });
    whatIsYourExperienceField.val = 'educator';

    const isProUpgradeField = ExternalUtil.findDisplayFieldOrThrow({
      formDefinition,
      fieldName: FieldHtmlNameUtil.isProUpgrade,
    });
    isProUpgradeField.val = 'true';
  }
}
